import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@/environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isLmsRequest = req.url.startsWith(environment.apiBaseUrl);

  // Only opt-in to cookies for LMS API calls.
  if (!isLmsRequest) return next(req);

  // Cookie auth: never attach Bearer tokens; the browser sends HttpOnly cookies.
  // This also ensures CORS preflight requests don't include credentials, which would cause them to fail.
  return next(req.clone({ withCredentials: true }));
};
